//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import Tippy from '@tippyjs/react';
import styled from 'styled-components';

import { Mixins } from '@theme/mixins';

/**
 * The core tippy css provides important sizing & positioning
 * styles, particularly for the Popover arrow. DO NOT REMOVE.
 */
import 'tippy.js/dist/tippy.css';

/**
 * The Tippy library uses a lot of fairly involved CSS to correctly
 * position tooltips and their arrows. The easiest way for us to get
 * the correct styling for our popovers is to apply overrides, as then
 * we're still outsourcing the more complicated styling and associated logic.
 *
 * These overrides bring the Tippy styling inline with the Unison Popover styles.
 */
export const CuPopoverTippy = styled(Tippy)(
  ({ theme }) => `
  &.tippy-box {
    ${Mixins.Text.Body}
    background-color: ${theme.colors.white};
    border-radius: ${theme.borderRadii[1]};
    border: ${theme.borderWidths[1]} solid ${theme.colors.gray2};
    will-change: filter;
    filter: drop-shadow(0px 1px 3px rgba(0,0,0,0.24));
  }

  & > .tippy-content {
    padding: 0px;
  }

  & > .tippy-arrow {
    color: ${theme.colors.white};

    &::after {
      content: '';
      position: absolute;
      z-index: -1;
      border-color: transparent;
      border-style: solid;
    }
  }

  &[data-placement^='top'] .tippy-arrow {
    &::after {
      top: 17px;
      left: 1px;
      border-top-color: ${theme.colors.gray2};
      border-width: 7px 7px 0px;
    }
  }

  &[data-placement^='bottom'] .tippy-arrow {
    &::after {
      bottom: 17px;
      left: 1px;
      border-bottom-color: ${theme.colors.gray2};
      border-width: 0px 7px 7px;
    }
  }

  &[data-placement^='left'] .tippy-arrow {
    &::after {
      left: 17px;
      top: 1px;
      border-left-color: ${theme.colors.gray2};
      border-width: 7px 0px 7px 7px;
    }
  }

  &[data-placement^='right'] .tippy-arrow {
    &::after {
      right: 17px;
      top: 1px;
      border-width: 7px 7px 7px 0;
      border-right-color: ${theme.colors.gray2};
    }
  }
`,
);
